import React from 'react';
import { Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import ChargebackDocumentUploader from 'domains/ChargebackUpload/ChargebackDocumentUploader';

function UploadCardSkeleton(): JSX.Element {
  return (
    <Card>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="4">
          <ChargebackDocumentUploader.Skeleton />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default UploadCardSkeleton;
